"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackSubmitSearch = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackSubmitSearch(search_term, search_type, search_original_query, click_url, search_suggest_count) {
    const eventAction = () => {
        if (search_type === enums_1.SearchType.MatchingSearchList ||
            search_type === enums_1.SearchType.PopularCategories) {
            return 'Submit Matching search list';
        }
        return `Submit ${search_type}`;
    };
    const eventData = {
        eventName: enums_1.GA4EventName.SubmitSearch,
        feature_category: enums_1.GA4FeatureCategory.Search,
        search_term,
        search_type,
        search_original_query,
        click_url,
        search_suggest_count,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        event: 'JS_Event',
        eventCategory: enums_1.EventCategory.Search,
        eventAction: eventAction(),
        eventLabel: eventData.search_term,
        eventData,
    });
}
exports.trackSubmitSearch = trackSubmitSearch;
//# sourceMappingURL=trackSubmitSearch.js.map